import { EditionAPI } from '../api/datamanager/EditionAPI';

export class Edition {
    constructor(updateCallback, provider = "", isToUpdate = true) {
        this.date = undefined;
        this.dateSrt = () => this.parseDate(this.date);
        this.network = 0;
        this.draftNetwork = "";
        this.planning = "";
        this.draftPlanning = "";
        this.county = 0;
        this.draftCounty = "";
        this.setProvider(provider, false);

        this.objects = {
            network: null,
            draftNetwork: [],
            planning: [],
            draftPlanning: [],
            county: null,
            draftCounty: [],
        }

        this.isUpdating = isToUpdate;
        this.observers = [];
        this.pendingObservers = [];
        this.updateCallback = updateCallback;

        if (isToUpdate) {
            this.updateSync(new Date());
        }
    }

    // ---------------------

    getNetworkEditionName(edition) {
        if (edition === this.network || edition === this.objects.network.id) {
            return this.objects.network.name;
        }

        return "<Desconhecido>";
    }

    getDraftNetworkEditionName(edition) {
        const draftNetworkEdition = this.objects.draftNetwork.find(value => edition === value.id);
        if (undefined === draftNetworkEdition) {
            return "<Desconhecido>";
        }

        return draftNetworkEdition.name;
    }

    getPlanningEditionName(edition) {
        const planningEdition = this.objects.planning.find(value => edition === value.id);
        if (undefined === planningEdition) {
            return "<Desconhecido>";
        }

        return planningEdition.name;
    }

    getDraftPlanningEditionName(edition) {
        const draftPlanningEdition = this.objects.draftPlanning.find(value => edition === value.id);
        if (undefined === draftPlanningEdition) {
            return "<Desconhecido>";
        }

        return draftPlanningEdition.name;
    }

    getCountyEditionName(edition) {
        if (edition === this.county || edition === this.objects.county.id) {
            return this.objects.county.name;
        }

        return "<Desconhecido>";
    }

    getDraftCountyEditionName(edition) {
        const draftCountyEdition = this.objects.draftCounty.find(value => edition === value.id);
        if (undefined === draftCountyEdition) {
            return "<Desconhecido>";
        }

        return draftCountyEdition.name;
    }

    getAllNetworkEditionsArray() {
        const array = [];

        array.push(this.objects.network);
        return array.concat(this.objects.draftNetwork).filter(edition => null !== edition);
    }

    setProvider(provider, isToUpdate = true) {
        if ("string" === typeof provider) {
            this.provider = provider.split(':')[0];
        }
        else {
            this.provider = "";
        }

        if (isToUpdate && undefined !== this.date) {
            this.update(this.date);
        }
    }

    // ---------------------

    parseDate(date) {
        if (date instanceof Date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }

        return date;
    }

    isSameDate(date) {
        if (date instanceof Date && this.date instanceof Date) {
            return date.getTime() === this.date.getTime()
        }

        return this.parseDate(date) === this.parseDate(this.date);
    }

    updateSync(date, errorCallback = undefined, force = false) {
        if (!force && this.isSameDate(date)) {
            return; // Nothing to be done
        }

        this.isUpdating = true;
        this.notifyStartUpdate();

        this.date = date;

        const editionApi = new EditionAPI();
        const apiResult = editionApi.getSync(this.parseDate(date), this.provider);
        if (apiResult !== undefined) {
            this.processUpdate(apiResult);
        }
    }

    update(date, errorCallback = undefined, force = false, forceUpdate = false) {
        if (!force && this.isSameDate(date)) {
            return; // Nothing to be done
        }

        this.isUpdating = true;
        this.notifyStartUpdate();

        this.date = date;

        const editionApi = new EditionAPI();
        const apiResult = editionApi.get(this.parseDate(date), this.provider);
        apiResult.then((result) => {
            this.processUpdate(result, forceUpdate);
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }

            this.isUpdating = false;
            this.notifyEndUpdate();
            this.drainPendingObservers();
        });
    }

    processUpdate(result, forceUpdate = false) {
        const resultObject = JSON.parse(result);

        // Active Network
        const updatedActiveNetwork = resultObject.activeNetworkEncoded || "0";
        if (forceUpdate  || "0" === `${this.provider}` || updatedActiveNetwork !== this.network) {
            this.objects.network = resultObject.activeNetworkEdition;
            this.network = updatedActiveNetwork;
            this.notifyNetwork();
        }

        // Draft Network
        const updatedDraftNetwork = resultObject.draftNetworkEncoded || "0";
        if (forceUpdate || "0" === `${this.provider}` || updatedDraftNetwork !== this.draftNetwork) {
            this.objects.draftNetwork = resultObject.draftNetworkEditions;
            this.draftNetwork = updatedDraftNetwork;
            this.notifyDraftNetwork();
        }

        // Active Planning
        const updatedPlanning = resultObject.activePlanningEncoded || "0";
        if (forceUpdate || "0" === `${this.provider}` || updatedPlanning !== this.planning) {
            this.objects.planning = resultObject.activePlanningEditions;
            this.planning = updatedPlanning;
            this.notifyPlanning();
        }

        // Draft Planning
        const updatedDraftPlanning = resultObject.draftPlanningEncoded || "0";
        if (forceUpdate || "0" === `${this.provider}` || updatedDraftPlanning !== this.draftPlanning) {
            this.objects.draftPlanning = resultObject.draftPlanningEditions;
            this.draftPlanning = updatedDraftPlanning;
            this.notifyDraftPlanning();
        }

        // Active County
        const updatedActiveCounty = resultObject.activeCountyEncoded || "0";
        if (forceUpdate || "0" === `${this.provider}` || updatedActiveCounty !== this.county) {
            this.objects.county = resultObject.activeCountyEdition;
            this.county = updatedActiveCounty;
            this.notifyCounty();
        }

        // Draft County
        const updatedDraftCounty = resultObject.draftCountyEncoded || "0";
        if (forceUpdate || "0" === `${this.provider}` || updatedDraftCounty !== this.draftCounty) {
            this.objects.draftCounty = resultObject.draftCountyEditions;
            this.draftCounty = updatedDraftCounty;
            this.notifyDraftCounty();
        }

        this.isUpdating = false;
        if ("function" === typeof this.updateCallback) {
            this.updateCallback();
        }
        this.notifyEndUpdate();
        this.drainPendingObservers();
    }

    // ---------------------

    addObserver(observer) {
        this.observers.push(observer);

        if (!this.isUpdating) {
            this.callUpdate(observer, "updateNetwork");
            this.callUpdate(observer, "updateDraftNetwork");
            this.callUpdate(observer, "updatePlanning");
            this.callUpdate(observer, "updateDraftPlanning");
            this.callUpdate(observer, "updateCounty");
            this.callUpdate(observer, "updateDraftCounty");
            this.callUpdate(observer, "endUpdate");
        } else {
            this.pendingObservers.push(observer);
        }
    }

    // Observers added while an update is in flight don't necessarily get
    // caught up by notifyNetwork()/etc., since those only fire when a value
    // actually changed. Force-feed them once the in-flight update settles.
    drainPendingObservers() {
        const observersToCatchUp = this.pendingObservers;
        this.pendingObservers = [];

        observersToCatchUp.forEach((observer) => {
            this.callUpdate(observer, "updateNetwork");
            this.callUpdate(observer, "updateDraftNetwork");
            this.callUpdate(observer, "updatePlanning");
            this.callUpdate(observer, "updateDraftPlanning");
            this.callUpdate(observer, "updateCounty");
            this.callUpdate(observer, "updateDraftCounty");
            this.callUpdate(observer, "endUpdate");
        });
    }

    removeObserver(observer) {
        this.observers.pop(observer);
        this.pendingObservers = this.pendingObservers.filter((pending) => pending !== observer);
    }

    // ---------------------

    notifyStartUpdate() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "startUpdate");
        }
    }

    notifyEndUpdate() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "endUpdate");
        }
    }

    notifyNetwork() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updateNetwork");
        }
    }

    notifyDraftNetwork() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updateDraftNetwork");
        }
    }

    notifyPlanning() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updatePlanning");
        }
    }

    notifyDraftPlanning() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updateDraftPlanning");
        }
    }

    notifyCounty() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updateCounty");
        }
    }

    notifyDraftCounty() {
        for (const idx in this.observers) {
            this.callUpdate(this.observers[idx], "updateDraftCounty");
        }
    }

    // ---------------------

    callUpdate(observer, callback) {
        if ("function" === typeof observer[callback] && undefined !== this.date) {
            observer[callback](this);
        }
    }
}
